import { render, staticRenderFns } from "./RefundPage.vue?vue&type=template&id=5e215e42&"
import script from "./RefundPage.vue?vue&type=script&lang=js&"
export * from "./RefundPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports